import React from 'react';
import { X, AlertTriangle } from 'lucide-react';

interface DeleteUserModalProps {
  email: string;
  onConfirm: (email: string) => void;
  onClose: () => void;
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({ email, onConfirm, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="flex items-start mb-4">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
              <AlertTriangle className="h-5 w-5 text-red-600" />
            </div>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-gray-900">Delete User</h3>
            <p className="mt-1 text-sm text-gray-500">
              Are you sure you want to delete the user with email "{email}"? This action cannot be undone.
            </p>
          </div>
          <button
            onClick={onClose}
            className="ml-auto flex-shrink-0 p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="h-5 w-5 text-gray-400" />
          </button>
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(email)}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Delete User
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteUserModal;